// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 453 ? "eef9e134" : chunkId) + "." + {"48":"73cb51e2a447df42","69":"1dce2a0632e0941d","453":"61a995c2e81a25aa","461":"9f5d37a1d39af76d","683":"7eba61fd6b88634d","729":"550f0818e93ed8df","745":"8fd928f6f93a4895"}[chunkId] + ".js";
};